var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnFlag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.429688,
    width: 24,
    height: 17.1429,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_218_8888",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.429688,
    width: 24,
    height: 17.1429,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_218_8888)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0.429688H0V1.57254H24V0.429688ZM24 2.71582H0V3.85868H24V2.71582ZM0 5.00112H24V6.14397H0V5.00112ZM24 7.28711H0V8.42997H24V7.28711ZM0 9.57227H24V10.7151H0V9.57227ZM24 11.8583H0V13.0011H24V11.8583ZM0 14.1436H24V15.2864H0V14.1436ZM24 16.4297H0V17.5725H24V16.4297Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.429688,
    width: 10.2857,
    height: 8,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_218_8888)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.28568 2.14369C2.28568 2.45929 2.02984 2.71512 1.71425 2.71512C1.39866 2.71512 1.14282 2.45929 1.14282 2.14369C1.14282 1.8281 1.39866 1.57227 1.71425 1.57227C2.02984 1.57227 2.28568 1.8281 2.28568 2.14369ZM4.57139 2.14369C4.57139 2.45929 4.31556 2.71512 3.99997 2.71512C3.68437 2.71512 3.42854 2.45929 3.42854 2.14369C3.42854 1.8281 3.68437 1.57227 3.99997 1.57227C4.31556 1.57227 4.57139 1.8281 4.57139 2.14369ZM6.28568 2.71512C6.60127 2.71512 6.85711 2.45929 6.85711 2.14369C6.85711 1.8281 6.60127 1.57227 6.28568 1.57227C5.97009 1.57227 5.71425 1.8281 5.71425 2.14369C5.71425 2.45929 5.97009 2.71512 6.28568 2.71512ZM9.14282 2.14369C9.14282 2.45929 8.88699 2.71512 8.57139 2.71512C8.2558 2.71512 7.99997 2.45929 7.99997 2.14369C7.99997 1.8281 8.2558 1.57227 8.57139 1.57227C8.88699 1.57227 9.14282 1.8281 9.14282 2.14369ZM2.85707 3.8577C3.17266 3.8577 3.4285 3.60186 3.4285 3.28627C3.4285 2.97068 3.17266 2.71484 2.85707 2.71484C2.54148 2.71484 2.28564 2.97068 2.28564 3.28627C2.28564 3.60186 2.54148 3.8577 2.85707 3.8577ZM5.71415 3.28627C5.71415 3.60186 5.45831 3.8577 5.14272 3.8577C4.82713 3.8577 4.57129 3.60186 4.57129 3.28627C4.57129 2.97068 4.82713 2.71484 5.14272 2.71484C5.45831 2.71484 5.71415 2.97068 5.71415 3.28627ZM7.42861 3.8577C7.7442 3.8577 8.00003 3.60186 8.00003 3.28627C8.00003 2.97068 7.7442 2.71484 7.42861 2.71484C7.11301 2.71484 6.85718 2.97068 6.85718 3.28627C6.85718 3.60186 7.11301 3.8577 7.42861 3.8577ZM9.14286 4.42983C9.14286 4.74542 8.88702 5.00126 8.57143 5.00126C8.25584 5.00126 8 4.74542 8 4.42983C8 4.11424 8.25584 3.8584 8.57143 3.8584C8.88702 3.8584 9.14286 4.11424 9.14286 4.42983ZM6.28578 5.00126C6.60138 5.00126 6.85721 4.74542 6.85721 4.42983C6.85721 4.11424 6.60138 3.8584 6.28578 3.8584C5.97019 3.8584 5.71436 4.11424 5.71436 4.42983C5.71436 4.74542 5.97019 5.00126 6.28578 5.00126ZM4.57132 4.42983C4.57132 4.74542 4.31549 5.00126 3.9999 5.00126C3.6843 5.00126 3.42847 4.74542 3.42847 4.42983C3.42847 4.11424 3.6843 3.8584 3.9999 3.8584C4.31549 3.8584 4.57132 4.11424 4.57132 4.42983ZM1.71425 5.00126C2.02984 5.00126 2.28568 4.74542 2.28568 4.42983C2.28568 4.11424 2.02984 3.8584 1.71425 3.8584C1.39866 3.8584 1.14282 4.11424 1.14282 4.42983C1.14282 4.74542 1.39866 5.00126 1.71425 5.00126ZM3.42854 5.57227C3.42854 5.88786 3.1727 6.14369 2.85711 6.14369C2.54152 6.14369 2.28568 5.88786 2.28568 5.57227C2.28568 5.25667 2.54152 5.00084 2.85711 5.00084C3.1727 5.00084 3.42854 5.25667 3.42854 5.57227ZM5.14282 6.14369C5.45841 6.14369 5.71425 5.88786 5.71425 5.57227C5.71425 5.25667 5.45841 5.00084 5.14282 5.00084C4.82723 5.00084 4.57139 5.25667 4.57139 5.57227C4.57139 5.88786 4.82723 6.14369 5.14282 6.14369ZM7.99996 5.57227C7.99996 5.88786 7.74413 6.14369 7.42854 6.14369C7.11295 6.14369 6.85711 5.88786 6.85711 5.57227C6.85711 5.25667 7.11295 5.00084 7.42854 5.00084C7.74413 5.00084 7.99996 5.25667 7.99996 5.57227ZM8.57139 7.28655C8.88699 7.28655 9.14282 7.03071 9.14282 6.71512C9.14282 6.39953 8.88699 6.14369 8.57139 6.14369C8.2558 6.14369 7.99997 6.39953 7.99997 6.71512C7.99997 7.03071 8.2558 7.28655 8.57139 7.28655ZM6.85711 6.71512C6.85711 7.03071 6.60127 7.28655 6.28568 7.28655C5.97009 7.28655 5.71425 7.03071 5.71425 6.71512C5.71425 6.39953 5.97009 6.14369 6.28568 6.14369C6.60127 6.14369 6.85711 6.39953 6.85711 6.71512ZM3.99997 7.28655C4.31556 7.28655 4.57139 7.03071 4.57139 6.71512C4.57139 6.39953 4.31556 6.14369 3.99997 6.14369C3.68437 6.14369 3.42854 6.39953 3.42854 6.71512C3.42854 7.03071 3.68437 7.28655 3.99997 7.28655ZM2.28568 6.71512C2.28568 7.03071 2.02984 7.28655 1.71425 7.28655C1.39866 7.28655 1.14282 7.03071 1.14282 6.71512C1.14282 6.39953 1.39866 6.14369 1.71425 6.14369C2.02984 6.14369 2.28568 6.39953 2.28568 6.71512Z",
    fill: "url(#paint0_linear_218_8888)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_218_8888",
    x: 1.14282,
    y: 1.57227,
    width: 8,
    height: 6.71436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_218_8888"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_218_8888",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_218_8888",
    x1: 1.14282,
    y1: 1.57227,
    x2: 1.14282,
    y2: 7.28655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EnFlag.4840f5993b071c06806d5bcfec166574.svg";